import { useRef, useState, type ReactElement } from 'react';
import { Icon } from '../Icon/Icon';
import styles from './Dropzone.module.scss';

export interface DropzoneProps {
  accept: string;
  label: string;
  hint?: string;
  onFiles(files: File[]): void;
  disabled?: boolean;
}

/** MED-UC-1: выбор файлов кнопкой или перетаскиванием. */
export function Dropzone({ accept, label, hint, onFiles, disabled }: DropzoneProps): ReactElement {
  const input = useRef<HTMLInputElement>(null);
  const [active, setActive] = useState(false);
  return (
    <div
      className={`${styles.dropzone} ${active ? styles.active : ''}`}
      onDragOver={(event) => {
        event.preventDefault();
        setActive(true);
      }}
      onDragLeave={() => setActive(false)}
      onDrop={(event) => {
        event.preventDefault();
        setActive(false);
        if (!disabled) onFiles(Array.from(event.dataTransfer.files));
      }}
      onClick={() => !disabled && input.current?.click()}
      role="button"
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === 'Enter' || event.key === ' ') input.current?.click();
      }}
      aria-disabled={disabled}
    >
      <Icon name="upload" size={28} />
      <strong>{label}</strong>
      {hint ? <span>{hint}</span> : null}
      <input
        ref={input}
        type="file"
        multiple
        accept={accept}
        hidden
        aria-label={label}
        data-testid="media-file-input"
        onChange={(event) => {
          const files = Array.from(event.target.files ?? []);
          event.target.value = '';
          if (files.length > 0) onFiles(files);
        }}
      />
    </div>
  );
}
